import { StrictLocalizeFunction } from "./localization";

/**
 * Extracts the user-friendly uppercase order number,
 * from the given order token.
 */
export function orderNumber(orderToken: string): string;
/**
 * Extracts the user-friendly uppercase order number,
 * from the given order entity.
 */
export function orderNumber(order: {
  token: string | undefined;
}): string | undefined;

export function orderNumber(
  orderToken: string | { token: string | undefined } | undefined
): string | undefined {
  return withoutPrefix(orderToken)?.toUpperCase();
}

export const withoutPrefix = (
  token: string | { token: string | undefined } | undefined
): string | undefined => {
  const tokenString =
    typeof token === "object" ? (token.token as string) : (token as string);
  if (!tokenString?.includes("_")) {
    return tokenString;
  }
  return tokenString.split("_")[1];
};

export const orderNumberWithHashtag = (
  orderToken: string,
  strictLocalize: StrictLocalizeFunction
): string =>
  strictLocalize(
    {
      defaultMessage: "#{orderToken}",
      description: {
        text: "orderToken is the order number of an invoice, The # represents number symbol and is a prefix of the order number. Please localize the # symbol too",
        img: "https://cdn.faire.com/fastly/6ca3f5425873007eabb27ce14da2576fc0e22b850085c59b7ffc66fed9a1892e.png",
      },
    },
    { orderToken: orderNumber(orderToken) }
  );
